import { render, staticRenderFns } from "./Crews.vue?vue&type=template&id=7b4e5d88"
import script from "./Crews.vue?vue&type=script&lang=js"
export * from "./Crews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports